import React from 'react';

const SvgHome = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.11081 17.5C4.12915 17.5 3.33331 16.6833 3.33331 15.675V8.33999C3.33331 7.78582 3.57915 7.26082 3.99998 6.91499L8.88915 2.89999C9.20153 2.6413 9.5944 2.49976 9.99998 2.49976C10.4056 2.49976 10.7984 2.6413 11.1108 2.89999L15.9991 6.91499C16.4208 7.26082 16.6666 7.78582 16.6666 8.33999V15.675C16.6666 16.6833 15.8708 17.5 14.8891 17.5H5.11081Z"
        stroke="#161617"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.91663 17.5V12.9167C7.91663 12.4746 8.09222 12.0507 8.40478 11.7382C8.71734 11.4256 9.14127 11.25 9.58329 11.25H10.4166C10.8587 11.25 11.2826 11.4256 11.5951 11.7382C11.9077 12.0507 12.0833 12.4746 12.0833 12.9167V17.5"
        stroke="#161617"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default SvgHome;
